import { useContext } from "react";
import Button from "components/shared/Button";
import { Context } from "Context";
import appConfig from "config.json";

const { brands } = appConfig;
const MessageCountBadge = ({
	counter,
	action,
	analyticsLinkId,
	link,
	showInMobile = false,
}) => {
	const {
		config: { brand },
		isMobileView,
	} = useContext(Context);

	const shouldrenderInMobile =
		brands[brand]?.renderNotificationBadgeMobile && showInMobile;
	if (
		(!counter || (!action && !link) || isMobileView || Number(counter) === 0) &&
		!shouldrenderInMobile
	) {
		return null;
	}

	const mainClass = "syndicated-message-badge";

	return action ? (
		<Button
			className={`${mainClass}${"__button"}`}
			onClick={action}
			analyticsLinkId={analyticsLinkId}
		>
			<div className={`${mainClass}${"__content"}`}>{counter}</div>
		</Button>
	) : (
		link && (
			<Button
				className={`${mainClass}${"__button"}`}
				link
				linkContent={link}
				analyticsLinkId={analyticsLinkId}
			>
				<div className={`${mainClass}${"__content"}`}>{counter}</div>
			</Button>
		)
	);
};
export default MessageCountBadge;
